
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sok",
      function () {
        return require("private-next-pages/sok/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sok"])
      });
    }
  